import React from "react";

import MyReviewsRoute from "../../features/reviews/MyReviewsRoute";
import HexAuthWrapper from "../../components/HexAuthWrapper";

const MyReviews = () => (
  <div className="my-reviews-page full-bleed">
    <HexAuthWrapper>
      <MyReviewsRoute />
    </HexAuthWrapper>
  </div>
);

export default MyReviews;
